var map = {
	"./errorPOP.svg": 8238,
	"./errorSP.svg": 8475,
	"./logoPOP.svg": 6196,
	"./logoSP.svg": 7445,
	"./notFoundPOP.svg": 2917,
	"./notFoundSP.svg": 3213,
	"./putFailedPOP.svg": 9418,
	"./putFailedSP.svg": 1643,
	"./readyPOP.svg": 5747,
	"./readySP.svg": 7980
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8684;